(function () {
  var SHOW_AFTER_PX = 800;
  var fixBtn = document.querySelector('.c__lp-fixbtn');
  if (!fixBtn) return;

  function toggleFixBtn() {
    fixBtn.classList.toggle('is-active', window.scrollY > SHOW_AFTER_PX);
  }

  toggleFixBtn();
  window.addEventListener('scroll', toggleFixBtn, { passive: true });
})();

/* セクションのふわっと表示・グラフが伸びる動き・数字のカウントアップ */
(function () {
  var lp = document.querySelector('.c__lp');
  if (!lp || !('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  lp.classList.add('c__lp-js');

  // ふわっと出す単位：FV以外のセクションと、特長の見出し・01〜05
  var fadeTargets = lp.querySelectorAll(':scope > section:not(.c__lp-fv):not(.c__lp-features), .c__lp-features > *');
  var fadeObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-inview');
      fadeObserver.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  fadeTargets.forEach(function (el) {
    el.classList.add('c__lp-fade');
    fadeObserver.observe(el);
  });

  // 数字は 0 から data-count の値まで数え上げる（小数の桁数は data-count に合わせる）
  function format(value, decimals) {
    return value.toFixed(decimals);
  }

  function countUp(el) {
    var target = parseFloat(el.dataset.count);
    var decimals = (el.dataset.count.split('.')[1] || '').length;
    var duration = 1500;
    var start = null;
    function step(time) {
      if (start === null) start = time;
      var progress = Math.min((time - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = format(target * eased, decimals);
      if (progress < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  var counts = lp.querySelectorAll('.c__lp-count');
  counts.forEach(function (el) {
    var decimals = (el.dataset.count.split('.')[1] || '').length;
    el.textContent = format(0, decimals);
  });

  var playObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      if (el.classList.contains('c__lp-count')) {
        countUp(el);
      } else {
        // グラフの外枠は高さがないので、横棒が画面に入ったら外枠に印を付ける
        el.closest('.c__lp-polarize-chart').classList.add('is-inview');
      }
      playObserver.unobserve(el);
    });
  }, { rootMargin: '0px 0px -15% 0px' });

  counts.forEach(function (el) { playObserver.observe(el); });
  lp.querySelectorAll('.c__lp-polarize-chart__bar').forEach(function (el) { playObserver.observe(el); });
})();
